<template>
  <div class="container" :class="isMobile ? 'root-container' : 'content-container'">
    <InviteDialog v-show="dialogVisible" :bgi="dialogBgi" :show-close="true" :error-msg="errorMsg" @close="closeDialog">
      <div v-if="isSlot" class="dialog-slot-box">
        <div v-if="isRegisterAction">
          {{ isRegisterAction }}
          <p class="modal-title">XIN CHÚC MỪNG</p>
          <p class="dialog-text tip">Bạn đã đăng ký thành công</p>
          <p class="dialog-text tip">Tự động đăng nhập trong 5s</p>
          <p class="dialog-text">Lưu ý: Hội viên cần cập nhật đầy đủ thông tin
            SĐT, Email, Bank chính chủ để được nhận
            code tân thủ
          </p>
        </div>
        <div v-else>
          <p class="modal-title">XIN CHÚC MỪNG</p>
          <p class="dialog-text tip">BẠN ĐÃ ĐĂNG NHẬP THÀNH CÔNG</p>
          <p class="dialog-text dialog-text1">
            <span class="tip2">Tự động đăng nhập trong</span>
            <span class="tip tip1">5s</span>
          </p>
        </div>
      </div>
    </InviteDialog>
    <sys-loading :loading="loading" />
    <div :class="isMobile ? 'root' : 'content'">
      <div class="main">
        <div class="logo-box" v-if="isMobile">
          <img class="logo" src="../assets/invite/logo.png" />
        </div>
        <div class="left">
          <div class="left-head">
            <img src="../assets/invite/left-head.png" class="left-img" alt="">
            <img src="../assets/invite/left-bg.png" class="left-img1" alt="">
          </div>
          <InviteSwiper v-if="!isMobile" :swiper-images="swiperImages" :navImg="navImg" :navigator="true"
            :slidesPerView="slidesPerView" />
        </div>
        <div class="right">
          <img class="logo" v-if="!isMobile" src="../assets/invite/logo.png" />
          <div class="form">
            <div class="tags">
              <img @click="changeTab(true)" :src='isRegisterAction ? registerBtn.active : registerBtn.default' alt=""
                class="tag register">
              <img @click="changeTab(false)" :src='!isRegisterAction ? loginBtn.active : loginBtn.default' alt=""
                class="tag">
            </div>
            <div class="inputs">
              <el-form :model="form" ref="regform" :rules="regrules">
                <el-form-item prop="userName">
                  <div class="form-input">
                    <img src="../assets/invite/name.png" />
                    <input v-model="form.userName" placeholder="Tên đăng nhập" maxlength="20" autocomplete="off" />
                  </div>
                </el-form-item>
                <el-form-item prop="password">
                  <div class="form-input">
                    <img src="../assets/invite/password.png" />
                    <input v-model="form.password" type="password" placeholder="Mật khẩu" maxlength="10"
                      autocomplete="off" />
                    <img class="last-icon" :src="require(`../assets/euro/icon-${showPwd ? 'show' : 'hide'}.png`)"
                      @click="showPwd = !showPwd" />
                  </div>
                </el-form-item>
                <el-form-item prop="checkPass" v-if="isRegisterAction">
                  <div class="form-input">
                    <img src="../assets/invite/password.png" />
                    <input v-model="form.checkPass" type="password" placeholder="Nhập lại mật khẩu" maxlength="10"
                      autocomplete="off" />
                  </div>
                </el-form-item>
                <el-form-item prop="verificationCode" v-if="isRegisterAction">
                  <div class="form-code-box">
                    <div class="form-input form-code-input-box" style="margin-bottom: 0;">
                      <img src="../assets/invite/anquan.png" />
                      <input class="form-code-input" v-model="form.verificationCode" autocomplete="off"
                        placeholder="Mã xác minh" />
                    </div>
                    <div class="code" @click="getVerify"><img class="img" :src="codeImg" alt="code" /></div>
                  </div>
                </el-form-item>
              </el-form>
              <span v-if="!isRegisterAction" class="error" @click="gotoPage">Quên Mật Khẩu?</span>
            </div>
            <v-captcha ref="vcaptcha1" :dialogVisible="dialogVisible" :showCheck="showCheck" @cb="handleConfirm"
              :vstyle="isMobile
                ? {
                  width: '50%',
                  height: '18%',
                  position: 'absolute',
                  left: '25%',
                  bottom: '-6%'
                }
                : {
                  width: '50%',
                  height: '18%',
                  position: 'absolute',
                  left: '25%',
                  bottom: 0
                }
                " :nativeButton="isMobile
                  ? {
                    width: '100%',
                    height: '47px'
                  }
                  : {
                    width: '100%',
                    height: '65px'
                  }
                  ">
              <div v-show="isRegisterAction" class="submitBtn reg" :style="`background-image: url(${require('../assets/invite/btn-register.gif')});background-size: contain;`
                " @click="submitAction(1)"></div>
            </v-captcha>
            <div v-show="!isRegisterAction" class="submitBtn login" :style="`background-image: url(${require('../assets/invite/btn-login.gif')});background-size: contain;`
              " @click="submitAction(2)">
            </div>
          </div>
          <div class="btm" v-if="!isMobile">
            <a :href="contacts.facebook" target="_blank"><img src="../assets/invite/icon-fb.png" /></a>
            <a :href="contacts.telegram" target="_blank"><img src="../assets/invite/icon-tg.png" /></a>
          </div>
        </div>
        <InviteSwiper v-if="isMobile" :swiper-images="swiperImages" :navImg="navImg" :navigator="true"
          :slidesPerView="slidesPerView" />
      </div>
    </div>
  </div>
</template>

<script>
import 'amfe-flexible'
import md5 from "js-md5";
import InviteSwiper from './invite/inviteSwiper.vue';
import InviteDialog from './invite/inviteDialog.vue';
import {swiper, swiperSlide} from "vue-awesome-swiper";

import {CONTRACTS, DOMAIN_AGENT_CODE, FORM_VALID_MESSAGE} from "../utils/constant";
import {createCustomer, getCode, userGetGoPageUrl, userLogin, userRegister} from "../utils/request";
import {encodePlatformUrl, isMobile,} from "../utils/tools";
import "../../static/js/initRem";
import {captcha} from "@/mixins/captcha";

export default {
  name: "invite",
  mixins: [captcha],
  components: { swiper, swiperSlide, InviteSwiper, InviteDialog },
  data() {
    var validateName = (rule, value, callback) => {
      if (value === "" || !value) {
        callback(new Error("*Tên đăng nhập không được để trống"));
      } else {
        console.log('value', value);
        if (value.length < 4) {
          callback(new Error("*4 - 20 ký tự bao gồm số và chữ"));
        }
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" || String(value).length < 6) {
        callback(new Error("*6 - 15 ký tự bao gồm số và chữ"));
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" || String(value).length < 6) {
        callback(new Error("*6 - 15 ký tự bao gồm số và chữ"));
      } else if (value !== this.form.password) {
        callback(new Error("*Xác nhận mật khẩu không trùng khớp!"));
      } else {
        callback();
      }
    };
    var validateverificationCode = (rule, value, callback) => {
      console.log('......validateverificationCode', value)
      if (value === "" || value == undefined) {
        callback(new Error("*Mã xác minh không được để trống"));
      } else {
        callback();
      }
    };
    return {
      time: 5,
      contacts: CONTRACTS,
      isMobile: isMobile(),
      regrules: {
        userName: {
          validator: validateName,
          trigger: "change"
        },
        password: {
          validator: validatePass,
          trigger: "change"
        },
        checkPass: {
          validator: validatePass2,
          trigger: "change"
        },
        verificationCode: {
          validator: validateverificationCode,
          trigger: "blur"
        },
      },
      swiperMobileVisible: false,
      isRegisterAction: true,
      dialogVisible: false,
      loading: false,
      resSuccess: false,
      isSlot: true,
      slidesPerView: 3,
      swiperOptions: {
        slidesPerView: 3,
        speed: 1000,
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        },
        navigation: {
          nextEl: ".next-btn",
          prevEl: ".prev-btn"
        }
      },
      showPwd: false,
      showRePwd: false,
      dialogBgi: require("../assets/invite/bgi-dialog.png"),

      form: {
        by: 1,
        userName: "",
        verificationCode: '',
        password: "",
        checkPass: '',//确认密码
        link: "",
        domain: "",
        inviteCode: null,
      },
      errorMsg: {
        title: "",
        content: ""
      },
      swiperImages: [
        require("../assets/invite/swiper-1.png"),
        require("../assets/invite/swiper-2.png"),
        require("../assets/invite/swiper-3.png"),
        require("../assets/invite/swiper-4.png")
      ],
      navImg: [
        require("../assets/invite/icon-l.png"),
        require("../assets/invite/icon-r.png"),
      ],
      loginBtn: {
        default: require("../assets/invite/register-btn-d.png"),
        active: require("../assets/invite/register-btn.png"),
      },
      registerBtn: {
        default: require("../assets/invite/login-btn-d.png"),
        active: require("../assets/invite/login-btn.png"),
      },
      tid: null,
      codeImg: '',
      goPageUrl: '',
    };
  },
  created() {
    this.getVerify();
    this.getGoPageUrl();
  },
  mounted() {
    if (!isMobile()) {
      window.onresize = () => {
        this.isMobile = isMobile();
      };
    }

  },
  methods: {
    getGoPageUrl() {
      userGetGoPageUrl({}).then(res => {
        console.log();
        const list = res.body.list;
        const randomIndex = Math.floor(Math.random() * list.length);
        this.goPageUrl = list[randomIndex].api_url;
        console.log(this.goPageUrl);
      });
    },
    changeTab(val) {
      this.form = {
        by: 1,
        userName: "",
        verificationCode: '',
        password: "",
        checkPass: '',//确认密码
        link: "",
        domain: "",
        inviteCode: null,
      };
      this.isRegisterAction = val;
      this.$refs.regform.resetFields();
    },
    gotoPage() {
      if (window.location.host === 'www.888b.earth') {
        window.open('https://www.8day.com', '_self')
      } else {
        window.open('https://www.8day.com', '_self')
      }
    },
    submitAction(type) {
      // let errorMsg = newValidForm(type, this.form);
      this.isSlot = false;
      let that = this;
      this.$refs.regform.validate(valid => {
        if (valid) {
          that.loading = true;
          // 登陆
          if (type == 2) {
            let temp = Object.assign({}, this.form);
            let params = {
              acctType: 6,
              by: 1,
              userName: temp.userName,
              password: md5(temp.password)
            };
            this.login(params);
          } else {
              this.form.inviteCode = (this.inviteCodeObj && this.inviteCodeObj[location.host]) || DOMAIN_AGENT_CODE[location.host] || "";
            this.form.domain = location.host;
            this.form.userName = this.form.userName;
            this.register();
          }
        }
      });
    },
    // 获取code 码
    getVerify() {
      getCode({}).then(res => {
        this.codeImg = res.body.data
      })
    },
    login(params) {
      userLogin(params)
        .then(res => {
          if (res.data.code == 0) {
            this.isSlot = true;
            this.setDialogMsg(
              'XIN CHÚC MỪNG',
              FORM_VALID_MESSAGE.loggedMsg,
            );
            const url = encodePlatformUrl(
              this.form.userName,
              md5(this.form.password),
              'https://8dn195.com/'
              // this.goPageUrl
            );
            console.log(url);
            setTimeout(() => {
              location.href = url;
            }, 5000);
          } else {
            this.setDialogMsg(
              FORM_VALID_MESSAGE.loginFailTitle, res.data.msg);
          }
          this.loading = false;
        })
        .catch(error => {
          this.setDialogMsg(FORM_VALID_MESSAGE.loginFailTitle, error.data);
          this.loading = false;
        });
    },
    register() {
      let params = (this.params = Object.assign({}, this.form));
      console.log(params);
      if (!/^[0-9a-zA-Z!~!@#$%^&*.,?]{6,15}$/.test(params.password)) {
        this.setDialogMsg(
          FORM_VALID_MESSAGE.registerFailTitle,
          FORM_VALID_MESSAGE.passwordMsg
        );
        this.loading = false;
        return;
      }
      this.handleCheck(this.handleConfirm);
    },
    handleConfirm(params = this.params) {
      // params.phone =params.phone.length == 10? params.phone: replacePhonePrefix(params.phone);
      params.userName = params.userName.toLowerCase();
      params.password = md5(params.password);
      console.log('请求参数' + params);
      this.isSlot = false;
      userRegister(params, this.captchaParams).then(res => {
        if (res.data.code == 0) {
          console.log('成功' + FORM_VALID_MESSAGE.registerMsg)
          this.isSlot = true;
          this.setDialogMsg(
            FORM_VALID_MESSAGE.registerTitle,
            FORM_VALID_MESSAGE.registerMsg
          );
          createCustomer(this.form);
          setTimeout(() => {
            location.href = encodePlatformUrl(
              this.form.userName,
              md5( this.form.password),
              this.goPageUrl
            );
          }, 5000);
        } else {
          console.log('失败' + res.data.msg)
          this.getVerify();
          this.setDialogMsg(
            FORM_VALID_MESSAGE.registerFailTitle,
            res.data.msg
          );
          // this.handleOpen(res.data.code);
        }
        this.loading = false;
      })
        .catch(error => {
          this.getVerify();
          this.setDialogMsg(FORM_VALID_MESSAGE.registerFailTitle, error.data);
          this.loading = false;
        });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    setDialogMsg(title, msg) {
      this.errorMsg.title = title;
      this.errorMsg.content = msg;
      this.dialogVisible = true;
    }
  }
};
</script>

<style lang="less" scoped>
::-webkit-input-placeholder {
  color: #5A5A5A80;

}

body {
  background-color: red;
}

.content,
.root {
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  overflow: hidden;
}


.content {
  background-image: url("../assets/invite/bgi-pc.png");
  background-size: 100% 100%;

  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding-left: 5%;
    padding-right: 3%;

    .left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .left-head {
        display: flex;
        flex-direction: column;
        align-items: center;

        .left-img {
          width: 2.333333rem;
          height: .649573rem;
          bottom: -.136752rem;
          position: relative;
        }

        .left-img1 {
          width: 4.393162rem;
          height: 3.068376rem;
        }
      }
    }

    .right {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      img.logo {
        width: .880342rem;
        height: .512821rem;
        margin-bottom: .094017rem;
        margin-top: .064103rem;
      }

      .form {
        width: 2.974359rem;
        height: 3.470085rem;
        background: url("../assets/invite/bgi-form.png") no-repeat;
        background-size: 100% 100%;

        .tags {
          width: 2.188034rem;
          height: .350427rem;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: auto;

          .tag {
            width: 1.153846rem;
            height: .350427rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;
          }
        }

        .inputs {
          width: 2.179487rem;
          max-height: 1.790598rem;
          margin: 0 auto;
          padding-top: .264957rem;
          margin-bottom: .25641rem;

          .el-form-item {
            width: 2.179487rem;
            height: .230769rem;
            margin-bottom: .235043rem;
          }


          .form-input {
            width: 2.179487rem;
            height: .230769rem;
            position: relative;
            margin: 0 auto;
            border-radius: .115385rem;
            display: flex;
            align-items: center;
            background-color: white;

            >img {
              width: .115385rem;
              height: .115385rem;
              margin-left: .076923rem;
              margin-right: .076923rem;
              // position: absolute;
              // left: .08547rem;
              // top: .055556rem;
            }

            input {
              background-size: 100% 100%;
              border: none;
              outline: none;
              font-size: .102564rem;
              color: #000;
              border-radius: .115385rem;
              flex: 1;
            }

            .last-icon {
              width: .17094rem;
              cursor: pointer;
            }
          }

          .form-code-box {
            display: flex;

            .form-code-input-box {
              display: flex;
              width: 1.367521rem;
              margin: 0;

              .form-code-input {
                width: 1rem;
              }
            }

            .code {
              width: .769231rem;
              height: .230769rem;
              border-radius: .115385rem;
              background-color: #fff;
              color: #000;
              text-align: center;
              margin-left: .042735rem;
              display: flex;
              align-items: center;
              cursor: pointer;

              img {
                width: .769231rem;
                height: .230769rem;
                border-radius: .115385rem;
              }
            }
          }

        }

        span.error {
          display: block;
          margin: .08547rem;
          color: #ffffff;
          font-size: .08547rem;
          text-decoration: underline;
          text-align: center;
          cursor: pointer;
          text-align: right;
        }

        .submitBtn {
          width: 1.367521rem;
          height: .683761rem;
          background-repeat: no-repeat;
          cursor: pointer;

          &.login {
            width: 1.367521rem;
            height: .683761rem;
            margin: auto;
          }
        }
      }

      .btm {
        display: flex;
        justify-content: space-between;
        gap: .141026rem;

        img {
          width: .350427rem;
          height: .350427rem;
          cursor: pointer;
        }
      }
    }

  }

}

.content-container {
  /deep/.mask-layer {
    .dialog-slot-box {
      width: 1.709402rem;
    }

    .modal-title {
      text-align: center;
      font-size: .17094rem;
      font-family: UTMErieBlack;
      font-weight: bold;
      margin: 0;
      color: #FFFFFF;
    }

    .dialog-text {
      color: #fff;
      font-size: .076923rem;
      line-height: .128205rem;
      text-align: center;
      padding: 0;
      margin: 0;
    }

    .dialog-text1 {
      line-height: .17094rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tip {
      color: #00ffec;
      font-weight: 500;
    }

    .tip1 {
      padding-left: .021368rem;
      line-height: .17094rem;
      font-size: .102564rem;
      font-weight: 700;
      font-family: roboto;
    }

    .tip2 {
      height: .128205rem;
      line-height: .128205rem;
    }
  }

  /deep/ .el-form-item__error {
    color: #fff;
    font-size: .076923rem;
    padding-top: .07265rem;
  }
}


.root-container {
  /deep/ .el-form-item__error {
    color: #fff;
    font-size: 0.18rem;
  }

  /deep/.mask-layer {
    .dialog-slot-box {
      width: 6.5rem;
    }

    .modal {
      width: 3.33rem;
    }

    .modal-title {
      text-align: center;
      font-size: .32rem;
      font-family: UTMErieBlack;
      font-weight: bold;
      margin: 0;
      color: #FFFFFF;
    }

    .dialog-text {
      color: #fff;
      font-size: 0.24rem;
      line-height: .24rem;
      text-align: center;
      padding: 0;
      margin: 0;
    }

    .dialog-text1 {
      line-height: .32rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tip {
      color: #00ffec;
      font-weight: 500;
    }

    .tip1 {
      padding-left: .021368rem;
      line-height: .32rem;
      font-size: .26rem;
      font-weight: 700;
      font-family: roboto;
    }

    .tip2 {
      height: .32rem;
      line-height: .32rem;
    }
  }

}



@media only screen and (max-width: 767px) {
  /deep/.mask-layer {
    .dialog-slot-box {
      width: 1.709402rem;
    }

    .modal-title {
      text-align: center;
      font-size: .17094rem;
      font-family: UTMErieBlack;
      font-weight: bold;
      margin: 0;
      color: #FFFFFF;
    }

    .dialog-text {
      color: #fff;
      font-size: .076923rem;
      line-height: .128205rem;
      text-align: center;
      padding: 0;
      margin: 0;
    }

    .dialog-text1 {
      line-height: .17094rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .tip {
      color: #00ffec;
      font-weight: 500;
    }

    .tip1 {
      padding-left: .021368rem;
      line-height: .17094rem;
      font-size: .102564rem;
      font-weight: 700;
      font-family: roboto;
    }

    .tip2 {
      height: .128205rem;
      line-height: .128205rem;
    }
  }
}



.root {
  height: auto;
  background-image: url("../assets/invite/bgi-m.png");
  background-size: 100% 100%;
  padding-bottom: .41rem;

  /deep/ .swiper-box {
    width: 7.12rem;
    padding: 0 0.18rem;

    .swiper-container {
      width: 100%;
    }

    .btn-prev {
      width: .28rem;
      margin-right: 0.18rem;
    }

    .btn-next {
      width: .28rem;
      margin-left: 0.18rem;
    }
  }

  .main {
    display: flex;
    flex-flow: column;
    align-items: center;

    .logo-box {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;

      .logo {
        width: 1.52rem;
        padding-top: 0.1rem;
        margin-left: 0.07rem;
        text-align: left;
      }
    }

    .left {
      height: auto;
      margin-top: 0;
      justify-content: center;
      position: relative;
      top: -0.22rem;

      .left-head {
        display: flex;
        flex-direction: column;

        .left-img {
          width: 5.46rem;
          margin: 0 auto;
        }

        .left-img1 {
          width: 6.76rem;
          margin: 0 auto;
          position: relative;
          top: -0.22rem;
        }
      }
    }

    .right {
      position: relative;
      top: -0.22rem;
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: space-between;

      .logo {
        width: 50%;
      }

      .form {
        width: 6.07rem;
        height: 7.01rem;
        background-image: url("../assets/invite/bgi-form.png");
        background-size: 100% 100%;

        .tags {
          width: 100%;
          height: 14%;
          position: relative;
          top: -4%;
          display: flex;
          align-items: center;
          justify-content: center;

          .tag {
            width: 2.14rem;
            height: 0.74rem;
            display: flex;
            justify-content: center;
            align-items: center;
            background-size: 100% 100%;
            cursor: pointer;
            position: relative;
          }

          .register {
            width: 2.4rem;
          }
        }

        .inputs {
          width: 4.16rem;
          max-height: 4.12rem;
          position: relative;
          margin: auto;
        }

        .form-input {
          width: 4.16rem;
          margin: 0 auto 0;
          display: flex;
          align-items: center;
          background-color: #fff;
          border-radius: .8rem;
          height: .54rem;

          img {
            width: .27rem;
            height: .27rem;
            margin-left: 0.2rem;
          }

          input {
            flex: 1;
            max-width: 3rem;
            background-color: #fff;
            border-radius: .8rem;
            border: none;
            text-indent: 0.1rem;
            outline: none;
            color: #000;
          }

          .last-icon {
            width: .4rem;
          }
        }

        .form-code-box {
          display: flex;

          .form-code-input-box {
            width: 2.58rem;
            display: flex;
          }

          .form-code-input {
            width: 1.9rem;
          }

          .code {
            margin-left: .1rem;
            background-color: #fff;
            width: 1.68rem;
            height: .54rem;
            border-radius: .8rem;
            line-height: .54rem;

            img {
              border-radius: .8rem;
              width: 100%;
            }
          }
        }

        span.error {
          display: block;
          margin: 0.20rem;
          color: #ffffff;
          font-size: 0.24rem;
          text-decoration: none;
          text-align: right;
        }

        .submitBtn {
          width: 3.2rem;
          height: 1.06rem;
          cursor: pointer;
          margin: 0 auto;

          &.login {
            height: 25%;
            bottom: -10%;
            background-repeat: no-repeat;
          }

          &:active {
            bottom: -4px;
          }
        }
      }

      .btm {
        width: 30%;
        margin: 6vw auto 0;
        display: flex;
        justify-content: space-between;

        img {
          width: 50px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invite.vue